module.exports = __webpack_public_path__ + "static/media/rocket.54b16157.svg";